import App from "./App.svelte";

document.querySelectorAll(".cg_wrapper").forEach((container, index) => {
	if (!container.hasChildNodes()) {
		new App({
			target: container,
			props: {
				id: index,
				debug: container.dataset.debug,
				masquer_barre_outils: container.dataset.masquer_barre_outils,
				masquer_mode_liste: container.dataset.masquer_mode_liste,
				masquer_filtres_primaires: container.dataset.masquer_filtres_primaires,
				masquer_filtres_secondaires: container.dataset.masquer_filtres_secondaires,
				filtres_primaires: container.dataset.filtres_primaires,
				afficher_reseaux_sociaux: container.dataset.afficher_reseaux_sociaux,
				masquer_pagination: container.dataset.masquer_pagination,
				filtresParDefaut: {
					mode: container.dataset.mode,
					deux_colonnes: container.dataset.deux_colonnes,
					search: container.dataset.s,
					afficher_contenu_epingle: container.dataset.afficher_contenu_epingle,
					nombre: container.dataset.nombre,
					page: 1,
					type_contenus: container.dataset.type_contenus,
					premier_niveau: container.dataset.premier_niveau,
					enfants_de: container.dataset.enfants_de,
					exclude: container.dataset.exclude,
					reseau: container.dataset.filtre_reseau,
					public: container.dataset.filtre_public,
					taxonomies: container.dataset.taxonomies
				},
				filtres: {
					mode: container.dataset.mode,
					deux_colonnes: container.dataset.deux_colonnes,
					search: container.dataset.s,
					afficher_contenu_epingle: container.dataset.afficher_contenu_epingle,
					nombre: container.dataset.nombre,
					page: 1,
					type_contenus: container.dataset.type_contenus,
					premier_niveau: container.dataset.premier_niveau,
					enfants_de: container.dataset.enfants_de,
					exclude: container.dataset.exclude,
					reseau: container.dataset.filtre_reseau,
					public: container.dataset.filtre_public,
					taxonomies: container.dataset.taxonomies
				}
			}
		});
	}
});

export default app;
